import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { StorageService } from '../../core/services/storage/storage.service';
import { ToastService } from '../../core/services/toast/toast.service';
import { PlanDetails, Sim } from '../../interfaces/sims';
import { InventoryManagementService } from '../inventory-management/inventory-management.service';

@Injectable()
export class BuyNowInventoryCheckService {
  public isCheckingAvailability = signal(false);

  protected toasterService = inject(ToastService);

  protected inventoryManagementService = inject(InventoryManagementService);

  protected storageService = inject(StorageService);

  protected router = inject(Router);

  public navigateToBuyNow(sim: Sim, planDetails: PlanDetails): Observable<boolean> {
    if (!planDetails) {
      return of(false);
    }

    this.storageService.setEsimData({
      iccid: sim.iccid.toString(),
      esimId: sim.esimId.toString(),
      imsiId: sim.imsiId.toString(),
      name: sim.name,
      isEsimSelected: true,
      isBuyAgain: true,
    });

    return from(
      this.router.navigate([`/${planDetails.entity.slug}/${planDetails.plan.slug}/checkout`])
    );
  }
}
